import { type FilterProps, SelectColumnFilter } from "helpers/reactTable";
import React from "react";
import { list as trucks } from "sources/books/trucks";

const normalizeCarNumber = (value: string): string => value.replace(/[ _]/g, "").trim().toLowerCase();

export default function CarNumberColumnFilter({ column, ...props }: FilterProps) {
    return (
        <SelectColumnFilter
            {...props}
            column={column}
            selectProps={{
                url: trucks,
                inputProps: { name: column.id },
                propName: "number",
                filterFunc: normalizeCarNumber,
                filterOption: ({ label }: { label: string }, search: string) =>
                    normalizeCarNumber(label).includes(normalizeCarNumber(search)),
            }}
        />
    );
}
